"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveSlotChildIds = resolveSlotChildIds;
function resolveSlotChildIds({ slotNode, siblingIds, nodes, }) {
    const slotName = slotNode.name ?? null;
    if (!slotName) {
        return [...slotNode.children];
    }
    const slotIndex = getSlotIndex(slotNode, siblingIds, nodes);
    const assigned = siblingIds.filter(childId => {
        const child = nodes[childId];
        if (!child || child.id === slotNode.id || child.slot !== slotName) {
            return false;
        }
        const childSlotIndex = readSlotIndex(child);
        return childSlotIndex === null
            ? slotIndex === 0
            : childSlotIndex === slotIndex;
    });
    return assigned.length > 0 ? assigned : [...slotNode.children];
}
function getSlotIndex(slotNode, siblingIds, nodes) {
    const explicit = readSlotIndex(slotNode);
    if (explicit !== null)
        return explicit;
    let index = 0;
    for (const childId of siblingIds) {
        const child = nodes[childId];
        if (child?.id === slotNode.id)
            return index;
        if (child?.type === 'slot' && child.name === slotNode.name) {
            index += 1;
        }
    }
    return 0;
}
function readSlotIndex(node) {
    const value = node.slotIndex;
    return typeof value === 'number' && Number.isInteger(value) && value >= 0
        ? value
        : null;
}
